import React from "react";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SectionTwoBlockYoutube from "./SectionTwoBlockYoutube";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "3em 0",
    backgroundColor: theme.palette.colors.lightBlue,
    color: theme.palette.colors.black,
  },
}));

function SectionTwoYoutube() {
  const classes = useStyles();

  return (
    <Grid className={classes.root} container>
      <SectionTwoBlockYoutube heading="New Laptops" />
      <SectionTwoBlockYoutube
        heading="Headless CMS"
        imageSrc="https://picsum.photos/id/2/300/300"
      />
      <SectionTwoBlockYoutube text="much less text. keep the text content similar for best alignment. we're using 'flex-start' to keep the top of each cell aligned." />
    </Grid>
  );
}

export default SectionTwoYoutube;
